//
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'
import { required } from '@/services/validations'
import DispatchRequestDetailHeaders from './headers'

//
const CloseTransferBetweenWarehouseFields = [
    {
        name: 'close_comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario de cierre',
            rules: [required],
        },
    },
    {
        name: 'auth_code_simple',
        type: 'text-field',
        flex: {
            xs12: true,
        },
        props: {
            autofocus: true,
            label: 'Código de autorización',
            rules: [required],
            type: 'password',
        },
    },
]

//
export default ({ g_branch_office_id, triggerWarehouse }) => [
    {
        name: 'g_from_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_to_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Destino',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_from_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Origen',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'g_to_supervisor_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Solicitante',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'wh_selected_products',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: DispatchRequestDetailHeaders,
            noActions: true,
            noDataText: 'Sin productos.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: 'Items',
            pickerProps: {
                attachParams: {
                    stock_branch_office_id: g_branch_office_id,
                },
                filters: ProductFilters({ triggerWarehouse }).slice(0, -1),
                headers: JSON.parse(JSON.stringify(ProductHeaders)).filter((e,i)=> i!==5).map(e => {
                    if(e.value === 'stock_total') {
                        e.value = 'stock_branch_office'
                    }
                    return e
                }),
                noPagination: false,
                mapper: row => {
                    row['g_branch_office_id'] = g_branch_office_id
                    row['quantity'] = 1
                    row['received'] = 0
                    row['quantity_dispatch'] = 0
                    row['status'] = 'No Enviado'
                    row['stock'] = 0
                    row['wh_product_id'] = row.id
                    return row
                },
                paramFilter: {
                    type: 'item',                    
                },
                rowsPerPage: 15,
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            showNativePagination: true,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la guía',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
            rules: [required],
        },
    },
    {
        name: 'description',
        type: 'textarea',
        flex: {
            xs12: true,
            md6: true,
        },
        props: {
            label: 'Descripción',
        },
    },
    {
        name: 'dispatch_comment',
        type: 'textarea',
        flex: {
            xs12: true,
            md6: true,
        },
        props: {
            label: 'Comentario de despacho',
            readonly: true,
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
            md6: true,
        },
        props: {
            label: 'Comentario de recepción',
            readonly: true,
        },
    },
    {
        name: 'close_comment',
        type: 'textarea',
        flex: {
            xs12: true,
            md6: true,
        },
        props: {
            label: 'Comentario de cierre',
            readonly: true,
        },
    },
]

//
export { CloseTransferBetweenWarehouseFields }
